import { AutogenModelOrdersList, AutogenRowOrdersList } from "./autogen/AutogenModelOrdersList";

export class ModelOrdersList extends AutogenModelOrdersList<RowOrdersList> {
    constructor() {
        super(RowOrdersList);
    }
}

export class RowOrdersList extends AutogenRowOrdersList {
}